<template>
  <!-- start 自定义下拉框 -->
  <div class="options" @click="!disabled?unfold = !unfold:''">
    <div class="options-label">
      {{ index != null ? optionList[index].label : placeholder }}
    </div>
    <img
      src="@/assets/images/xia-icon.png"
      class="options-img"
      v-if="!unfold"
    />
    <img
      src="@/assets/images/top-icon.png"
      class="options-img"
      v-if="unfold"
    />
    <div class="options-content" v-if="unfold">
      <div
        class="options-list"
        :class="key == index ? 'select-options-list' : ''"
        v-for="(item, key) in optionList"
        :key="key"
        @click.stop="(index = key), (unfold = false)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
  <!-- end 自定义下拉框 -->
</template>

<script>
export default {
  name: "CustomOptions",
  data() {
    return {
      //是否展开
      unfold: false,
      // 选中位置
      index: null,
      // 选中对象
      val: this.value,
    };
  },
  props: {
    value: {
      typeof: String,
      default: null,
    },
    optionList: {
      typeof: Array,
      default: function () {
        return [];
      },
    },
    disabled: {
      typeof: Boolean,
      default: false
    },
    placeholder: {
      typeof: String,
      default: ''
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.val = newVal;
        this.index = null;
        this.optionList.forEach((item, key) => {
          if (item.label == newVal) {
            this.index = key;
          }
        });
      },
    },
    //监听是否启动
    val: {
      immediate: true, //首次监听
      deep: true,
      handler(newVal) {
        this.$emit("update:value", newVal);
      },
    },
    index: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal != null) {
          this.val = this.optionList[this.index].label;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.options {
  margin-top: 10px;
  width: 400px;
  height: 34px;
  border: 1px solid #c3cbd1;
  border-radius: 2px 2px 2px 2px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  position: relative;
  box-sizing: border-box;
  .options-label {
    color: #526070;
    font-weight: 400;
    font-size: 14px;
  }
  .options-img {
    width: 7px;
    height: 4px;
  }
  .options-content {
    position: absolute;
    width: 400px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #c3cbd1;
    left: -1px;
    top: 32px;
    padding: 4px 4px;
    box-sizing: border-box;
    z-index: 998;
    .options-list {
      width: 100%;
      padding: 6px 14px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: #526070;
      cursor: pointer;
    }
    .options-list:hover {
      background: #e9f1fa;
    }
    .select-options-list {
      background: #e9f1fa;
    }
  }
}
</style>
